export const IFRAME = {
  HEIGHT: {
    DEFAULT: 300,
    SMALL: 350,
    TABLET: 400,
    LARGE: 450,
    EXTRA_LARGE: 500,
    DOUBLE_EXTRA_LARGE: 600
  }
};

export const ICONS = {
  WELCOME_PAGE_DOWNLOAD_LINKS: {
    DESKTOP: {
      WIDTH: 30,
      HEIGHT: 30
    },
    MOBILE: {
      WIDTH: 20,
      HEIGHT: 20
    }
  },
  CHECK_MARK: {
    DEFAULT: {
      WIDTH: 20,
      HEIGHT: 20
    },
    ACTIVITY_SUMMARY: {
      WIDTH: 30,
      HEIGHT: 30
    }
  },
  CLONE: {
    DEFAULT: {
      WIDTH: 16,
      HEIGHT: 16
    }
  },
  GLOBAL_NO: {
    DEFAULT: {
      WIDTH: 25,
      HEIGHT: 25
    }
  },
  INSTALL_OUTLINE: {
    DEFAULT: {
      WIDTH: 30,
      HEIGHT: 30
    },
    EMBEDDED_VIEW: {
      WIDTH: 20,
      HEIGHT: 20
    }
  },
  NOTE: {
    DEFAULT: {
      WIDTH: 16,
      HEIGHT: 16
    }
  },
  PLAY_CIRCLE: {
    DEFAULT: {
      WIDTH: 24,
      HEIGHT: 24
    }
  },
  PLUS_CIRCLE: {
    DEFAULT: {
      WIDTH: 16,
      HEIGHT: 16
    },
    LOG_QUESTION: {
      WIDTH: 19,
      HEIGHT: 19
    }
  },
  ARROW_SUB_DOWN_LEFT: {
    DEFAULT: {
      WIDTH: 20,
      HEIGHT: 20
    }
  }
};
